<div>
    <app-search-bar [filters]="filters" [showPrimaryBtn]="false"
        (formValueChange)="handleFormValueChange($event)"></app-search-bar>
</div>

<ng-container *ngIf="loading; else SetData">
    <app-skeleton-loader [count]="5" type="card-pagamento"></app-skeleton-loader>
</ng-container>

<ng-template #SetData>
    <ng-container *ngIf="pagination.data?.length; else noData">
        <div class="list" *ngFor="let item of pagination.data">
            <app-card-pagamento [pagamento]="item" [codigo]="item.id" [titulo]="item?.utilizadorNome"
                [referencia]="item?.referenciaPagamento" [valorDoado]="item.valorDoadoTotal"
                [data]="item.dataCriacaoFormatada" [canal]="item?.metodoPagamento" [estado]="item.estadoApoio"
                [tipoPagamento]="item?.pagamento?.metodoPagamentoENUM" (rowClick)="verDetalhe(item)"
                (menuOpened)="setOpenedMenu($event)" [actions]="getActionsByEstado(item)">
            </app-card-pagamento>
        </div>
        <div class="pagination-controls">
            <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
                [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
                (pageChange)="onPageChange($event)">
            </app-paginator-control>
        </div>
    </ng-container>
</ng-template>

<p-drawer [(visible)]="visible" position="right" [style]="{'width': '650px'}"
    styleClass="!w-full md:!w-80 lg:!w-[30rem]" appendTo="body" [blockScroll]="true" [modal]="true">
    <ng-template #headless>
        @if (pagamentoID) {
        <div class="drawer-body-wrapper">
            <app-detalhe-pagamento [pagamentoID]="pagamentoID" (onCloseModal)="visible=false" />
        </div>
        }
    </ng-template>
</p-drawer>

<ng-template #noData>
    <div class="no-data">
        <app-data-void titulo="Nenhum pagamento encontrado" descricao="Tente novamente mais tarde."></app-data-void>
    </div>
</ng-template>

<app-loader *ngIf="loading"></app-loader>